<template>
  <div class="page-comp-update-feature">
    <jw-modal :visible="data.visible" @ok="handelOK" :ok-loading="loading" @cancel="handelCancel" class="product-update-modal" :mask-closable="false" title-align="start" width="920px" :body-style="{ height: '600px', padding: '0' }" :title="$t('编辑客户特征')">
      <jw-spin :loading="loading" :tip="$t('数据保存中') + '……'" :class="{ 'spin-loading': loading }">
        <jw-card :title="$t('基本特征')" :bordered="false" :header-style="{ border: 'none', padding: '0px 16px' }" class="product-update-card">
          <template v-if="data.form.basicFeature.length > 0">
            <jw-form :model="data.form" label-align="left" class="product-update-form" ref="editFormRef">
              <template v-for="(custom, index) in data.form.basicFeature" :key="custom.id">
                <jw-form-item :label="custom.fieldName" show-colon :field="`customForm.${index}.fieldValue`" class="product-update-form-item" :rules="rules(custom)" :validate-trigger="['blur', 'input', 'change']" :label-col-style="{ width: '150px' }" label-col-flex="auto">
                  <!-- 多行文本 -->
                  <jw-textarea
                    v-if="custom.fieldType == 1"
                    :placeholder="`${$t('请输入')}${custom.fieldName}`"
                    v-model="custom.fieldValue"
                    :auto-size="{
                      minRows: 2,
                      maxRows: 5
                    }"
                    class="product-update-form-item-value"
                  />
                  <!-- 单选按钮 -->
                  <jw-radio-group v-else-if="custom.fieldType == 2" class="product-update-form-item-value" v-model="custom.fieldValue">
                    <jw-radio v-for="item in JSON.parse(custom.fieldExt)" :key="item.value" :value="item.value">{{ item.label }}</jw-radio>
                  </jw-radio-group>
                  <!-- 多选按钮 -->
                  <jw-checkbox-group v-else-if="custom.fieldType == 3" class="product-update-form-item-value" v-model="custom.fieldValue">
                    <jw-checkbox v-for="item in JSON.parse(custom.fieldExt)" :key="item.value" :value="item.value">{{ item.label }}</jw-checkbox>
                  </jw-checkbox-group>
                  <!-- 下拉单选 -->
                  <jw-select v-else-if="custom.fieldType === 4" v-model="custom.fieldValue" :placeholder="`${$t('请选择')}${custom.fieldName}`" class="product-update-form-item-value" :options="JSON.parse(custom.fieldExt)" popup-container=".product-update-form-item" allow-clear allow-search> </jw-select>
                  <!-- 下拉多选 -->
                  <jw-select v-else-if="custom.fieldType === 5" :placeholder="`${$t('请选择')}${custom.fieldName}`" multiple class="product-update-form-item-value" v-model="custom.fieldValue" :options="JSON.parse(custom.fieldExt)" popup-container=".product-update-form-item" allow-search allow-clear> </jw-select>
                  <!-- 单行文本 -->
                  <jw-input v-else v-model="custom.fieldValue" :placeholder="`${$t('请输入')}${custom.fieldName}`" class="product-update-form-item-value" />
                </jw-form-item>
              </template>
            </jw-form>
          </template>
          <jw-empty v-else />
        </jw-card>
        <jw-card title="使用情况" :bordered="false" :header-style="{ border: 'none', padding: '0px 16px' }" class="product-update-card">
          <template v-if="data.useForm.useCondition.length > 0">
            <jw-form :model="data.useForm" label-align="left" ref="useFormRef" class="product-update-form">
              <template v-for="(custom, index) in data.useForm.useCondition" :key="custom.id">
                <jw-form-item :label="custom.fieldName" show-colon :field="`customForm.${index}.fieldValue`" class="product-update-form-item" :rules="rules(custom)" :validate-trigger="['blur', 'input', 'change']" :label-col-style="{ width: '150px' }" label-col-flex="auto">
                  <!-- 多行文本 -->
                  <jw-textarea
                    v-if="custom.fieldType == 1"
                    :placeholder="`${$t('请输入')}${custom.fieldName}`"
                    v-model="custom.fieldValue"
                    :auto-size="{
                      minRows: 2,
                      maxRows: 5
                    }"
                    class="product-update-form-item-value"
                  />
                  <!-- 单选按钮 -->
                  <jw-radio-group v-else-if="custom.fieldType == 2" class="product-update-form-item-value" v-model="custom.fieldValue">
                    <jw-radio v-for="item in JSON.parse(custom.fieldExt)" :key="item.value" :value="item.value">{{ item.label }}</jw-radio>
                  </jw-radio-group>
                  <!-- 多选按钮 -->
                  <jw-checkbox-group v-else-if="custom.fieldType == 3" class="product-update-form-item-value" v-model="custom.fieldValue">
                    <jw-checkbox v-for="item in JSON.parse(custom.fieldExt)" :key="item.value" :value="item.value">{{ item.label }}</jw-checkbox>
                  </jw-checkbox-group>
                  <!-- 下拉单选 -->
                  <jw-select v-else-if="custom.fieldType === 4" v-model="custom.fieldValue" :placeholder="`${$t('请选择')}${custom.fieldName}`" class="product-update-form-item-value" :options="JSON.parse(custom.fieldExt)" popup-container=".product-update-form-item" allow-clear allow-search> </jw-select>
                  <!-- 下拉多选 -->
                  <jw-select v-else-if="custom.fieldType === 5" :placeholder="`${$t('请选择')}${custom.fieldName}`" multiple class="product-update-form-item-value" v-model="custom.fieldValue" :options="JSON.parse(custom.fieldExt)" popup-container=".product-update-form-item" allow-search allow-clear> </jw-select>
                  <!-- 单行文本 -->
                  <jw-input v-else v-model="custom.fieldValue" :placeholder="`${$t('请输入')}${custom.fieldName}`" class="product-update-form-item-value" />
                </jw-form-item>
              </template>
            </jw-form>
          </template>
          <jw-empty v-else />
        </jw-card>
      </jw-spin>
    </jw-modal>
  </div>
</template>

<script setup>
import { reactive, ref } from 'vue';
import useLoading from '@/hooks/loading';
import { salesService } from '@/api/';
import { Message } from '@arco-design/web-vue';
import { useI18n } from 'vue-i18n';
const { t } = useI18n();
const { loading, setLoading } = useLoading(false);
const emits = defineEmits(['cb']);
const data = reactive({
  id: null,
  type: '',
  visible: false,
  form: {
    basicFeature: []
  },
  useForm: {
    useCondition: []
  },
  basicInfo: false,
  useInfo: false,
  isRepeat: true
});
const editFormRef = ref();
const useFormRef = ref();
const open = (params) => {
  console.log(82, params);
  data.id = params.id;
  data.type = params.type;
  data.form.basicFeature = params.basicFeature;
  data.useForm.useCondition = params.useCondition;
  data.form.basicFeature.forEach((item) => {
    if (item.fieldType === 3 || item.fieldType === 5) {
      item.fieldValue = item.fieldValue && item.fieldValue?.split(',');
    }
  });
  data.useForm.useCondition.forEach((item) => {
    if (item.fieldType === 3 || item.fieldType === 5) {
      item.fieldValue = item.fieldValue && item.fieldValue?.split(',');
    }
  });
  console.log(122, data.form.basicFeature, data.useForm.useCondition);
  data.visible = true;
};
// 确认按钮
const handelOK = async () => {
  if (data.form.basicFeature.length > 0) {
    await editFormRef.value?.validate((a) => {
      basicErrorValidate(a);
    });
  }
  if (data.useForm.useCondition.length > 0) {
    await useFormRef.value?.validate((a) => {
      useErrorValidate(a);
    });
  }
  console.log(data.basicInfo, data.useInfo);
  if (data.form.basicFeature.length > 0 && data.useForm.useCondition.length > 0) {
    if (data.basicInfo && data.useInfo) {
      allParams();
    }
  } else if ((data.form.basicFeature.length > 0 && data.basicInfo) || (data.useForm.useCondition.length > 0 && data.useInfo)) {
    allParams();
  }
};
// 基本信息表单效验
const basicErrorValidate = (errors) => {
  if (errors) {
    data.basicInfo = false;
    const errorArray = {};
    Object.values(errors)?.forEach((key, index) => {
      errorArray[key.field] = { status: 'error', message: '' };
      Object.values(errorArray)?.forEach((i, ind) => {
        if (index === ind) {
          i.message = key.message;
        }
      });
    });
    editFormRef.value?.setFields(errorArray);
    useFormRef.value?.setFields(errorArray);
    return;
  } else {
    console.log(344, data.isRepeat);
    if (data.isRepeat) {
      data.basicInfo = true;
    } else {
      data.basicInfo = false;
    }
  }
};
// 价格信息表单效验
const useErrorValidate = (errors) => {
  if (errors) {
    data.useInfo = false;
    const errorArray = {};
    Object.values(errors)?.forEach((key, index) => {
      errorArray[key.field] = { status: 'error', message: '' };
      Object.values(errorArray)?.forEach((i, ind) => {
        if (index === ind) {
          i.message = key.message;
        }
      });
    });
    editFormRef.value?.setFields(errorArray);
    useFormRef.value?.setFields(errorArray);
    return;
  } else {
    data.useInfo = true;
  }
};
// 汇总接口参数
const allParams = () => {
  // 编辑产品的参数数据处理-----N
  const editParams = {
    id: data.id,
    type: data.type,
    fieldValues: []
  };
  data.form.basicFeature?.forEach((item) => {
    const { id, settingId, fieldKey, fieldValue } = item;
    if (item.fieldType === 3 || item.fieldType === 5) {
      console.log(201, fieldValue);
      editParams.fieldValues.push({
        id,
        settingId,
        fieldKey,
        fieldValue: fieldValue?.join(',') || null
      });
    } else {
      editParams.fieldValues.push({
        id,
        settingId,
        fieldKey,
        fieldValue
      });
    }
  });
  data.useForm.useCondition?.forEach((item) => {
    const { id, settingId, fieldKey, fieldValue } = item;
    if (item.fieldType === 3 || item.fieldType === 5) {
      editParams.fieldValues.push({
        id,
        settingId,
        fieldKey,
        fieldValue: fieldValue?.join(',') || null
      });
    } else {
      editParams.fieldValues.push({
        id,
        settingId,
        fieldKey,
        fieldValue
      });
    }
  });
  console.log('调编辑接口,编辑的参数', editParams);
  addOrUpdateFeature(editParams);
};
// 编辑客户特征接口
const addOrUpdateFeature = async (params) => {
  setLoading(true);
  try {
    const json = await salesService.addOrUpdateFeature(params);
    if (!json.error) {
      console.log(73, json.result);
      Message.success(t('编辑成功'));
      emits('cb');
    } else {
      Message.error(json.error?.msg || t('操作失败'));
    }
    data.visible = false;
    setLoading(false);
  } catch (e) {
    console.log(e);
    data.visible = false;
    setLoading(false);
    Message.error(e.message || e.statusText || t('操作失败'));
  }
};
// 取消编辑弹窗
const handelCancel = () => {
  data.visible = false;
  console.log(241, editFormRef.value, useFormRef.value);
  editFormRef.value?.clearValidate(); //取消表单验证
  editFormRef.value?.resetFields(); //清空抽屉表单元素setFields
  useFormRef.value?.clearValidate(); //取消表单验证
  useFormRef.value?.resetFields(); //清空抽屉表单元素setFields
  data.form.basicFeature = [];
  data.useForm.useCondition = [];
};
// 表单效验
const rules = (basic) => {
  if (basic.isRequired) {
    if (basic.fieldType === 0 || basic.fieldType === 1) {
      return {
        required: basic.isRequired,
        message: `${basic.fieldName}${t('是必填项')}`
      };
    } else {
      return {
        required: basic.isRequired,
        message: `${basic.fieldName}${t('是必选项')}`
      };
    }
  } else {
    return {};
  }
};

defineExpose({ open });
</script>
<style scoped lang="less">
@import './index.less';
</style>
